$(document).ready(() => {
    const PAGE_LENGTH = 10;

    $('.playerStatsBlock').each(setupTable);

    function setupTable() {
        const $playerStatsBlock = $(this);

        let positionFilter = 'all';
        let gamesTypeFilter = 'all';
        let tournamentFilter = 'all';
        let tournamentTierFilter = 'all';
        let tournamentTypeFilter = $playerStatsBlock.data('tournament-type')
            ? '' + $playerStatsBlock.data('tournament-type')
            : 'all';
        let displayStart = 0;
        let order = [[PLAYERS_SHORT_STATS ? 6 : 7, 'desc']];

        const currentUrl = TRNMNT_helpers.parseUrl();
        const $playerPositionFilter = $playerStatsBlock.find('.playerPositionFilter li');
        const $gameTypeFilter = $playerStatsBlock.find('.gameTypeFilter');
        const $tournamentFilter = $playerStatsBlock.find('.tournamentFilter');
        const $tournamentTierFilter = $playerStatsBlock.find('.tournamentTierFilter');
        const $tournamentTypeFilter = $playerStatsBlock.find('.tournamentTypeFilter');

        const preserveFiltering = currentUrl.segments.indexOf('player') !== -1;

        if (preserveFiltering && currentUrl.params) {
            if (currentUrl.params.ppf) {
                $playerPositionFilter.find('button').removeClass('active');
                $playerPositionFilter.find(`button[data-position=${currentUrl.params.ppf}]`).addClass('active');
                positionFilter = currentUrl.params.ppf;
            }
            if (currentUrl.params.pgtf) {
                $gameTypeFilter.val(currentUrl.params.pgtf);
                gamesTypeFilter = currentUrl.params.pgtf;
            }
            if (currentUrl.params.ptf) {
                $tournamentFilter.val(currentUrl.params.ptf);
                tournamentFilter = currentUrl.params.ptf;
            }
            if (currentUrl.params.pttrf) {
                $tournamentTierFilter.val(currentUrl.params.pttrf);
                tournamentTierFilter = currentUrl.params.pttrf;
            }
            if (currentUrl.params.pttf) {
                $tournamentTypeFilter.val(currentUrl.params.pttf);
                tournamentTypeFilter = '' + currentUrl.params.pttf;
            }
            if (currentUrl.params.pds) {
                displayStart = currentUrl.params.pds;
            }
            if (currentUrl.params.poc && currentUrl.params.pod) {
                order = [[currentUrl.params.poc, currentUrl.params.pod]];
            }
        }

        switchBestPlayers();
        // console.log(currentUrl);

        const columns = TRNMNT_helpers.playerTableColumns(() => {
            return positionFilter;
        }, positionFilter === 'goalie');

        const tableColumns = PLAYERS_SHORT_STATS
            ? [
                columns.index, //Порядковый 0
                columns.number, //Номер игрока 1
                columns.avatar, //Аватар 2
                columns.name, //Имя 3
                columns.position, //Позиция 4

                columns.games,//GP 5

                columns.points,//P 6
                columns.goals,//G 7
                columns.assists,//A 8

                columns.wins,//W 9
                columns.loses,// L 10
                columns.goals_against,// GA 11
            ]
            : [
                columns.index, //Порядковый 0
                columns.number, //Номер игрока 1
                columns.avatar, //Аватар 2
                columns.platform, //Платформа 3
                columns.name, //Имя 4
                columns.position, //Позиция 5
                columns.games,//GP 6

                columns.points,//P 7
                columns.goals,//G 8
                columns.assists,//A 9
                columns.plus_minus,//+/- 10
                columns.shots,//S 11
                columns.shots_percent,//S% 12
                columns.faceoff_percent,//FO% 13
                columns.passes_percent,//P% 14
                columns.takeaways,//TA 15
                columns.interceptions,//INT 16
                columns.giveaways,//TA 17
                columns.blocked_shots,//BS 18
                columns.power_play_goals,//PPG 19
                columns.shorthanded_goals,//SHG 20
                columns.penalty_minutes,//PIM 21
                columns.game_winning_goals,//GWG 22
                columns.hits,//Hits 23

                columns.wins,//W 24
                columns.loses,// L 25
                columns.saves_percent,// SV% 246
                columns.saves,// Svs 27
                columns.goals_against,// GA 28
                columns.goal_against_per_game,// GAA 29
                columns.shootouts,// SO 30
            ];

        const $table = $playerStatsBlock.find('.playersStatsTable')
            // .on('processing.dt', function (e, settings, processing) {
            //     $('#players_processing')
            //         .addClass('bg-dark')
            //         .css('display', processing ? 'block' : 'none')
            //         .html('Загружаются данные...');
            // })
            .DataTable({
                language: {
                    url: '/dataTables.ru.json'
                },
                scrollX: true,
                displayStart: displayStart,
                pageLength: PAGE_LENGTH,
                lengthChange: false,
                layout: {
                    bottomEnd: {
                        paging: {
                            firstLast: false,
                        },
                    },
                },
                info: false,
                // processing: true,
                serverSide: true,
                ajax: {
                    url: PLAYERS_URL,
                    data: function (d) {
                        if (positionFilter !== 'all') {
                            d.position = positionFilter;
                        }
                        if (TEAM_ID) {
                            d.team_id = TEAM_ID;
                        }
                        if (gamesTypeFilter !== 'all') {
                            d.games_type = gamesTypeFilter;
                        }
                        if (tournamentFilter !== 'all') {
                            d.tournament_id = tournamentFilter;
                        }
                        if (tournamentTierFilter !== 'all') {
                            d.tier = tournamentTierFilter;
                        }
                        if (tournamentTypeFilter !== 'all') {
                            d.tournament_type = tournamentTypeFilter;
                        }
                    },
                },
                order: order,
                search: {
                    return: true,
                },
                paging: !MAIN,
                searching: false,
                dataSrc: 'data',
                columns: tableColumns,
                createdRow(row) {
                    // $(row).addClass(tournamentTypeFilter === '3' ? 'bg-3x3' : 'bg-dark');
                    const $row = $(row);
                    $row.addClass('bg-dark');
                    $row.find('td:last-child').addClass('rounded-end');
                },
                initComplete: (settings, json) => {
                    $('div.dataTables_filter input').addClass('form-control-dark');
                }
            });

        if (preserveFiltering) {
            $table.on('page.dt', function () {
                const info = $table.page.info();
                const displayStart = info.page * PAGE_LENGTH;
                TRNMNT_helpers.insertURLQueryParam('pds', displayStart);

                $([document.documentElement, document.body]).animate({
                    scrollTop: $playerStatsBlock.find('.playersStatsTable').offset().top - 160
                }, 0);
            });

            $table.on('order.dt', function () {
                // This will show: "Ordering on column 1 (asc)", for example
                const order = $table.order();
                TRNMNT_helpers.insertURLQueryParam('poc', order[0][0]);
                TRNMNT_helpers.insertURLQueryParam('pod', order[0][1]);
                TRNMNT_helpers.insertURLQueryParam('pds', 0);
            });
        }

        $playerPositionFilter.on('click', event => {
            event.preventDefault();
            positionFilter = $(event.target).data('position');

            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('ppf', positionFilter);
            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('pds', 0);
            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('poc', 7);
            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('pod', 'desc');

            const isGoalie = positionFilter === 'goalie';

            const fieldColumns = PLAYERS_SHORT_STATS
                ? [6, 7, 8]
                : [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
            for (const index of fieldColumns) {
                $table.column(index).visible(!isGoalie);
            }
            const goalieColumns = PLAYERS_SHORT_STATS
                ? [9, 10, 11]
                : [24, 25, 26, 27, 28, 29, 30]
            for (const index of goalieColumns) {
                $table.column(index).visible(isGoalie);
            }

            $table.order([
                [
                    isGoalie ? (PLAYERS_SHORT_STATS ? 9 : 24) : (PLAYERS_SHORT_STATS ? 6 : 7),
                    'desc'
                ]
            ]).rows().remove().draw();
        });

        $gameTypeFilter.on('change', event => {
            event.preventDefault();
            gamesTypeFilter = $(event.target).val();

            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('pgtf', gamesTypeFilter);
            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('pds', 0);
            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('poc', 7);
            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('pod', 'desc');

            $table.draw();
        });

        $tournamentFilter.on('change', event => {
            event.preventDefault();
            tournamentFilter = $(event.target).val();

            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('ptf', tournamentFilter);
            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('pds', 0);
            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('poc', 7);
            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('pod', 'desc');

            $table.draw();
        });

        $tournamentTierFilter.on('change', event => {
            event.preventDefault();
            tournamentTierFilter = $(event.target).val();

            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('pttrf', tournamentTierFilter);
            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('pds', 0);
            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('poc', 7);
            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('pod', 'desc');

            $table.draw();
        });

        $tournamentTypeFilter.on('change', onChangeTournamentTypeFilter);
        $('#teamTournamentType input').on('change', onChangeTournamentTypeFilter);

        function onChangeTournamentTypeFilter (event) {
            console.log('[players] change tournament type filter event fired');
            event.preventDefault();
            tournamentTypeFilter = '' + $(event.target).val();

            switchBestPlayers();

            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('pttf', tournamentTypeFilter);
            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('pds', 0);
            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('poc', 7);
            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('pod', 'desc');

            $table.draw();
        }

        function switchBestPlayers() {
            $('.bestPlayers').hide();
            let ttfClass = 'six';
            switch (tournamentTypeFilter) {
                case '3':
                    ttfClass = 'three';
                    break;
                case 'all':
                    ttfClass = 'all';
                    break;
            }
            const $block = $(`.bestPlayers.${ttfClass}`);
            $block.show();
        }
    }
});
